import actionCreator from "helpers/actionCreator"
import { createReducer } from "reduxsauce"
import { put, call, takeLatest, getContext } from "redux-saga/effects"
import { get as getApi } from "api"
import { Creators as PortfolioCreators } from "modules/portfolio-root/model"
import { Creators as ExperimentsCreators } from "modules/experiments/model"

export const { Types, Creators } = actionCreator("ompnt/components/alpha-theory-share", {
  loadSnapshot: ["snapshot"],
  fetchSnapshot: ["alphaTheoryShareId"],
})

export default createReducer({}, {})

export function* fetchSnapshot({ alphaTheoryShareId }) {
  try {
    const snapshot = yield call(getApi, `/api/alpha-theory-share/${alphaTheoryShareId}`, true)
    yield put(Creators.loadSnapshot(snapshot))
  } catch (err) {
    if (err.code === 404) {
      const { navigate } = yield getContext("router")
      yield call(navigate, "/404", { replace: true })
    }
  }
}

export function* unpackSnapshot({ snapshot }) {
  if (!snapshot) { return }
  const { payload } = snapshot
  const redirectUrl = getRedirectUrlFromSnapshot(snapshot)

  yield setSnapshot(payload)

  const { navigate } = yield getContext("router")
  yield call(navigate, redirectUrl)
}

function* setSnapshot(payload) {
  yield put(PortfolioCreators.setSnapshot(payload))
  yield put(ExperimentsCreators.setSnapshot(payload))
}

export function* saga() {
  yield takeLatest(Types.FETCH_SNAPSHOT, fetchSnapshot)
  yield takeLatest(Types.LOAD_SNAPSHOT, unpackSnapshot)
}

function getRedirectUrlFromSnapshot({ accountAlias, resourceId, resourceAlias }) {
  const id = resourceAlias ?? resourceId

  if (!accountAlias || !id) {
    return "/404"
  }

  return `/${accountAlias}/p/${id}/rebalance/experiments`
}
